import {
    generateTariffSummaryTable,
    IProps,
} from '~/src/features/internet/generateTariffSummaryTableFAQ/utils/generateTariffSummaryTable';

export const generateTariffSummaryTableFAQ = ({ tariffsForPage, code, companyName }: IProps) => ({
    question: `Чем отличаются тарифы интернета ${companyName}?`,
    answer: generateTariffSummaryTable({
        tariffsForPage,
        companyName,
        code,
    }),
    id: -1,
});

